import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "@/environments/environment";
import { PagingResponseModel } from "@/app/shared/interface/pagination.interface";
import { CartHistory, UpdateCartHistoryRequest } from "@/app/shared/interface/cart-history.interface";

@Injectable({
  providedIn: "root",
})
export class CartHistoryService {
  constructor(private http: HttpClient) {
  }

  getCartHistory(limit: number = 10, offset: number = 1) {
    const body = { limit, offset };
    return this.http.post<PagingResponseModel<CartHistory>>(
      `${environment.baseURL}order/cartHistory/retrieve-cart-history`, body,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  updateCartHistory(body: UpdateCartHistoryRequest) {
    return this.http.post<any>(
      `${environment.baseURL}order/cartHistory/update-cart-history`,
      body,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }
}

